import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { selectorIsRequirementExpiringInDays } from "./selectorIsRequirementExpiringInDays";

export const selectorIsRequirementExpiringInDaysFormatted = (
  requirement: PayeeRequirement
) => {
  const days = selectorIsRequirementExpiringInDays(requirement);

  return days <= 1 ? "today" : `in ${days}d`;
};
